import { Component, OnInit } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { TableItem } from '../../models/table';
import { FormsModule } from '@angular/forms';
import { ApiService, TeamData } from '../../services/api.service';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-skillteam-active',
  standalone: true,
  imports: [CommonModule, PrimeTemplate, TableModule, FormsModule,TooltipModule],
  templateUrl: './skillteam-active.component.html',
  styleUrl: './skillteam-active.component.scss',
})
export class SkillteamActiveComponent implements OnInit {
  teams: TeamData[] = [];

  data: TableItem[] = [];

  groups: string[] = [];

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.apiService.getAllTeams().subscribe(teams => {
      this.teams = teams;
      console.log(this.teams);
    });
  }

  onTeamActiveToggle(teamId: number, checked: boolean) {
    this.apiService.updateTeamActiveStatus(teamId, checked).subscribe({
      next: () => console.log(`Updated active status for ${teamId}`),
      error: err => console.error(`Error updating active status:`, err),
    });
  }

  getChecked(event: Event): boolean {
    return (event.target as HTMLInputElement)?.checked ?? false;
  }

  deleteTeam(teamId: number) {
    if (window.confirm('Are you sure you want to delete the team?')) {
      this.apiService.deleteTeam(teamId).subscribe({
        next: () => {
          alert(`Deleted team with ID ${teamId}`);
          // Ricarica la lista completa dei team dal backend
          this.apiService.getAllTeams().subscribe(teams => {
            this.teams = teams;
          });
        },
        error: err => console.error(`Error deleting team:`, err),
      });
    }
  }

  getTeamMembersAcronyms(rowData: any): string {
    if (!rowData.userLinks || !Array.isArray(rowData.userLinks) || rowData.userLinks.length === 0) {
      return '-';
    }
    return rowData.userLinks.map((u: any) => u.acronym).join(', ');
  }
}
